"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var CustomPropTypes = _interopRequireWildcard(require("../../../constants/PropTypes"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var ScopeGroup = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/scopes/ScopeGroup"));

var _offerings = require("../../../utils/offerings");

var _PermissionsList = _interopRequireDefault(require("./PermissionsList"));

var getI18nKey = function getI18nKey(key) {
  return "appMarketplace.detail.dataPermissions.permissions." + key;
};

var Permissions = function Permissions(_ref) {
  var connectionType = _ref.connectionType,
      homemade = _ref.homemade,
      requiredScopeGroups = _ref.requiredScopeGroups;
  var filteredScopeGroups = (0, _react.useMemo)(function () {
    return requiredScopeGroups.filter(function (scopeGroup) {
      return scopeGroup !== ScopeGroup.OAUTH;
    });
  }, [requiredScopeGroups]);

  if (homemade && !(0, _offerings.getIsStandardConnection)(connectionType)) {
    return _react.default.createElement("p", null, _react.default.createElement(_FormattedMessage.default, {
      message: getI18nKey('subheadingText.nativeAppPermissions')
    }));
  }

  if (filteredScopeGroups.isEmpty()) {
    return _react.default.createElement("p", null, _react.default.createElement(_FormattedMessage.default, {
      message: getI18nKey('subheadingText.noRequiredPermissions')
    }));
  }

  return _react.default.createElement(_react.Fragment, null, _react.default.createElement("p", null, _react.default.createElement(_FormattedMessage.default, {
    message: getI18nKey('subheadingText.requiredPermissions')
  })), _react.default.createElement(_PermissionsList.default, {
    requiredScopeGroups: filteredScopeGroups
  }));
};

Permissions.propTypes = {
  connectionType: CustomPropTypes.connectionType.isRequired,
  homemade: _propTypes.default.bool.isRequired,
  requiredScopeGroups: _reactImmutableProptypes.default.setOf(_propTypes.default.oneOf(Object.values(ScopeGroup))).isRequired
};
var _default = Permissions;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/detail/permissions/Permissions.js
// module id = 834
// module chunks = 209 210 211 212